/**
 * Serialises a nested JS value into FormData using Rails' parameter naming.
 *
 * Eight internal pages submit the create-candidate form and each one had its own copy of this;
 * they now share this one so the nested-attributes rules below only have to be right once.
 *
 * Arrays of objects are written with explicit indices — `experiences_attributes[0][title]` —
 * rather than the `[]` form. Rack turns `a[][x]=1&a[][y]=2` into a single hash and only starts a
 * new one when it sees a key it has already filled, so a row that omits a blank field (which this
 * function does, for undefined/null) silently merges into its neighbour. Indices remove the
 * guesswork, and `accepts_nested_attributes_for` reads the resulting numeric-keyed hash natively.
 * Arrays of scalars keep `[]`, which is what Rails wants for plain array columns.
 */
export const appendFormValue = (formData, key, value) => {
  if (value === undefined || value === null) return;

  if (value instanceof File || value instanceof Blob) {
    formData.append(key, value);
    return;
  }

  if (Array.isArray(value)) {
    value.forEach((item, index) => {
      const isRecord =
        item !== null &&
        typeof item === "object" &&
        !(item instanceof File) &&
        !(item instanceof Blob);
      appendFormValue(formData, isRecord ? `${key}[${index}]` : `${key}[]`, item);
    });
    return;
  }

  if (typeof value === "object") {
    Object.entries(value).forEach(([k, v]) => appendFormValue(formData, `${key}[${k}]`, v));
    return;
  }

  formData.append(key, String(value));
};

export default appendFormValue;
